export const SET_LAYOUT_VISIBLE = 'SET_LAYOUT_VISIBLE';

export const setLayoutVisible = (layoutVisible) => ({
	type: SET_LAYOUT_VISIBLE,
	layoutVisible,
});
